import { useEffect } from 'react';
import {
  Button,
  Typography,
  useTheme,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import CloseIcon from '@mui/icons-material/Close';
import UseCurrency from '@shared/hooks/UseCurrency';

const ModalMessages = ({
  difference,
  closeModal,
  selectedOption,
  notDisponible,
  flightsInUSD,
}) => {
  const { currency } = UseCurrency();
  const theme = useTheme();

  useEffect(() => {
    validateDifference();
  }, []);

  const validateDifference = () => {
    if (!difference?.difference) return;

    const totalDifference = difference?.difference.total_difference;

    if (flightsInUSD.isInUSD && Math.abs(totalDifference) < 5) {
      selectedOption(difference);
    } else if (flightsInUSD.isInARS && Math.abs(totalDifference) < 5000) {
      selectedOption(difference);
    }
  };

  return (
    <>
      <DialogTitle sx={{ position: 'relative', pb: 1 }}>
        <IconButton
          onClick={closeModal}
          sx={{
            position: 'absolute',
            right: 16,
            top: 16,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          textAlign: 'center',
          px: 4,
          pt: 2,
        }}
      >
        <WarningIcon
          sx={{
            fontSize: 80,
            color: theme.palette.error.main || 'red',
            my: 2,
          }}
        />

        <Typography
          variant="h6"
          sx={{
            color: '#000',
            fontWeight: 600,
            mb: 2,
          }}
        >
          {notDisponible
            ? 'Este vuelo no se encuentra disponible. Por favor seleccione otra opción.'
            : 'Disculpa, no pudimos confirmar tu tarifa.'}
        </Typography>

        {!notDisponible && (
          <Typography
            variant="body1"
            sx={{
              color: '#000',
              mb: 4,
              lineHeight: 1.5,
            }}
          >
            Podés continuar con tu vuelo seleccionado por{' '}
            <strong>
              {currency(difference?.difference?.total_difference)}
            </strong>{' '}
            o buscar otras opciones.
          </Typography>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'center',
          gap: 2,
          pb: 4,
        }}
      >
        {!notDisponible && (
          <Button
            onClick={() => selectedOption(difference)}
            variant="outlined"
            sx={{
              bgcolor: '#fff',
              borderColor: theme.primary,
              color: '#000',
              fontWeight: 600,
              textTransform: 'none',
              px: 4,
              py: 1.5,
              '&:hover': {
                bgcolor: '#f5f5f5',
                borderColor: theme.primary,
              },
            }}
          >
            Continuar
          </Button>
        )}

        <Button
          variant="contained"
          onClick={closeModal}
          sx={{
            bgcolor: theme.primary,
            color: theme.text1,
            fontWeight: 600,
            textTransform: 'none',
            px: 4,
            py: 1.5,
            '&:hover': {
              bgcolor: theme.primary,
              color: theme.text1,
            },
          }}
        >
          Ver otras alternativas
        </Button>
      </DialogActions>
    </>
  );
};

export default ModalMessages;
